import VueRouter, { RouteConfig } from 'vue-router'
import { BrowserUtil, RouterUtil, WeappUtil } from 'kuaidong-lib'
import { FileTypeEnum, GlobalConfigRouteMetaEnum } from 'kuaidong-model'

const Edit = () => import('../views/exam/RecordEdit.vue')
const Entry = () => import('../views/exam/RecordEntry.vue')
const Upload = () => import('../views/exam/RecordUpload.vue')
const Details = () => import('../views/exam/RecordDetails.vue')
const UploadFile = () => import('../views/exam/RecordUploadFile.vue')
const UploadMapping = () => import('../views/exam/RecordUploadMapping.vue')
const StudentDetails = () => import('../views/exam/RecordStudentsDetail.vue')

const ReportSchoolDetail = () => import('../views/exam/RecordReportSchoolDetails.vue')
const ReportGradePassesDetail = () => import('../views/exam/RecordReportGradePassesDetails.vue')
const ReportProjectDetail = () => import('../views/exam/RecordReportProjectDetail.vue')
const ReportGradeDetail = () => import('../views/exam/RecordReportGradeDetail.vue')
const ReportClazzDetail = () => import('../views/exam/RecordReportClazzDetails.vue')
const ReportClazzProjectDetail = () => import('../views/exam/RecordReportClazzProjectDetail.vue')
const ReportClazzList = () => import('../views/exam/RecordReportClazzList.vue')
const ReportStudentList = () => import('../views/exam/RecordReportStudentList.vue')
const ReportStudentDetails = () => import('../views/exam/RecordReportStudentDetails.vue')

const editRoute: RouteConfig = {
  path: '/exam-record-edit',
  name: 'exam_record_edit',
  component: Edit,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '编辑测试',
  },
}

const entryRoute: RouteConfig = {
  path: '/exam-record-entry',
  name: 'exam_record_entry',
  component: Entry,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '测试信息',
  },
}

const uploadRoute: RouteConfig = {
  path: '/exam-record-upload',
  name: 'exam_record_upload',
  component: Upload,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '导入测试名单',
  },
}

const detailsRoute: RouteConfig = {
  path: '/exam-record-details',
  name: 'exam_record_details',
  component: Details,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '测试详情',
  },
}

const uploadMappingRoute: RouteConfig = {
  path: '/exam-record-upload-mapping',
  name: 'exam_record_upload_mapping',
  component: UploadMapping,
  props: (route) => ({ ...route.params, ...route.query, onlyIdentifiers: !!+route.query.onlyIdentifiers }),
  meta: {
    title: '核对匹配结果',
  },
}

const uploadFileRoute: RouteConfig = {
  path: '/exam-record-upload-file',
  name: 'exam_record_upload_file',
  component: UploadFile,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '生成上报文件',
  },
}

const studentDetails: RouteConfig = {
  path: '/exam-record-students-detail',
  name: 'exam_record_students_detail',
  component: StudentDetails,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '数据明细',
  },
}

const reportShoolDetailRoute: RouteConfig = {
  path: '/exam-record-report-school-detail',
  name: 'exam_record_report_school_detail',
  component: ReportSchoolDetail,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '全校分析报告',
  },
}

const reportClazzDetailRoute: RouteConfig = {
  path: '/exam-record-report-clazz-detail',
  name: 'exam_record_report_clazz_detail',
  component: ReportClazzDetail,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '班级分析报告',
  },
}

const reportClazzProjectDetailRoute: RouteConfig = {
  path: '/exam-record-report-clazz-project-detail',
  name: 'exam_record_report_clazz_project_detail',
  component: ReportClazzProjectDetail,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '测试项目统计',
  },
}

const reportGradePassesDetailRoute: RouteConfig = {
  path: '/exam-record-report-grade-passes',
  name: 'exam_record_report_grade_passes',
  component: ReportGradePassesDetail,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '年级分布情况',
  },
}

const reportProjectDetailRoute: RouteConfig = {
  path: '/exam-record-report-project-detail',
  name: 'exam_record_report_project_detail',
  component: ReportProjectDetail,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '测试项目统计',
  },
}

const reportGradeDetailRoute: RouteConfig = {
  path: '/exam-record-report-grade-detail',
  name: 'exam_record_report_grade_detail',
  component: ReportGradeDetail,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '年级统计',
  },
}

const reportClazzListRoute: RouteConfig = {
  path: '/exam-record-report-clazz-list',
  name: 'exam_record_report_clazz_list',
  component: ReportClazzList,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '查看班级详情',
  },
}

const reportStudentListRoute: RouteConfig = {
  path: '/exam-record-report-student-list',
  name: 'exam_record_report_student_list',
  component: ReportStudentList,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '查看班级学生',
  },
}

const reportStudentDetailsRoute: RouteConfig = {
  path: '/exam-record-report-student-details',
  name: 'exam_record_report_student_details',
  component: ReportStudentDetails,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '分析报告',
    ignoreAuth: true,
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export default [
  editRoute,
  entryRoute,
  uploadRoute,
  detailsRoute,
  uploadMappingRoute,
  uploadFileRoute,
  studentDetails,
  // report
  reportClazzListRoute,
  reportStudentListRoute,
  reportStudentDetailsRoute,
  reportShoolDetailRoute,
  reportGradePassesDetailRoute,
  reportProjectDetailRoute,
  reportGradeDetailRoute,
  reportClazzDetailRoute,
  reportClazzProjectDetailRoute,
]

export function navigateToExamRecordEdit(router: VueRouter) {
  router.push({ name: editRoute.name })
}

export function redirectToExamRecordEdit(router: VueRouter) {
  router.replace({ name: editRoute.name })
}

export function navigateToExamRecordEntry(router: VueRouter, id: string) {
  router.push({ name: entryRoute.name, query: { id } })
}

export function redirectToExamRecordEntry(router: VueRouter, id: string) {
  router.replace({ name: entryRoute.name, query: { id } })
}

export function navigateToExamRecordUpload(router: VueRouter, id: string) {
  router.push({ name: uploadRoute.name, query: { id } })
}

export function navigateToExamRecordDetails(router: VueRouter, id: string) {
  router.push({ name: detailsRoute.name, query: { id } })
}

export function navigateToExamRecordUploadMapping(
  router: VueRouter,
  params: {
    id: string
    url: string
    onlyIdentifiers?: boolean
    fromWeapp?: boolean
    scene?: string
  }
) {
  const { id, url, onlyIdentifiers = false, fromWeapp = false, scene = '' } = params
  if (BrowserUtil.isWeapp()) {
    // 智慧课堂学生名单上传
    if (scene == 'intelligent_classroom_stu_namelist_upload') {
      const target = `${location.origin}${location.pathname}#/intelligent-classroom-batch-add-stu?id=${id}`
      WeappUtil.selectMessageFile({
        fileType: FileTypeEnum.Excel,
        target,
        isRedirect: fromWeapp,
        scene,
        id,
      })
    } else {
      WeappUtil.chooseMessageFile(
        FileTypeEnum.Excel,
        RouterUtil.buildUrlFromRoute(
          uploadMappingRoute,
          { id, url, onlyIdentifiers: onlyIdentifiers ? '1' : '0' },
          router
        ),
        fromWeapp,
        scene
      )
    }
  } else {
    router.push({ name: uploadMappingRoute.name, query: { id, url, onlyIdentifiers: onlyIdentifiers ? '1' : '0' } })
  }
}

export function redirectToExamRecordUploadMapping(
  router: VueRouter,
  params: {
    id: string
    url: string
    onlyIdentifiers?: boolean
    fromWeapp?: boolean
    scene?: string
  }
) {
  console.log('redirectToExamRecordUploadMapping', params)
  const { id, url, onlyIdentifiers = false, fromWeapp = false, scene = '' } = params
  if (BrowserUtil.isWeapp()) {
    // 智慧课堂学生名单上传
    if (scene == 'intelligent_classroom_stu_namelist_upload') {
      const target = `${location.origin}${location.pathname}#/intelligent-classroom-batch-add-stu?id=${id}`
      WeappUtil.selectMessageFile({
        fileType: FileTypeEnum.Excel,
        target: target,
        isRedirect: fromWeapp,
        scene,
        id,
      })
    } else {
      WeappUtil.chooseMessageFile(
        FileTypeEnum.Excel,
        RouterUtil.buildUrlFromRoute(
          uploadMappingRoute,
          { id, url, onlyIdentifiers: onlyIdentifiers ? '1' : '0' },
          router
        ),
        fromWeapp,
        scene
      )
    }
    router.go(-1)
  } else {
    router.replace({ name: uploadMappingRoute.name, query: { id, url, onlyIdentifiers: onlyIdentifiers ? '1' : '0' } })
  }
}

// report
export function navigateToExamRecordReportClazzList(router: VueRouter, id: string, reportId: string) {
  router.push({ name: reportClazzListRoute.name, query: { id, reportId } })
}

export function navigateToExamRecordReportStudentList(
  router: VueRouter,
  id: string,
  clazzId: string,
  reportId: string,
  aitestid: string,
  from?: 'aitest' | 'examtest' | ''
) {
  router.push({ name: reportStudentListRoute.name, query: { id, clazzId, reportId, aitestid, from } })
}

export function navigateToExamRecordReportStudentDetails(router: VueRouter, id: string) {
  router.push({ name: reportStudentDetailsRoute.name, query: { id } })
}
